import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IManageWhiteListParams, IWhiteListItem, IWhiteListParams } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 风控管理 - 白名单管理列表
 */
export async function queryWhiteList(params: IWhiteListParams) {
  let data = [] as IWhiteListItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IWhiteListItem[]; total: number }>(`${hostUrl}/side/risk/customer-allow/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: resData, total: resTotal } = context || {};

      data = resData || [];
      total = resTotal || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 风控管理 - 白名单管理 - 删除
 */
export async function deleteWhiteList(ids: number[]) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/risk/customer-allow/delete`, { ids });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 风控管理 - 白名单管理 - 导出
 */

export async function exportRiskWhiteList(params: IWhiteListParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(`${hostUrl}/side/risk/customer-allow/export`, params, { responseType: 'blob' });

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 风控管理 - 白名单管理 - 编辑
 */

export async function updateWhiteList(params: IManageWhiteListParams, isEdit: boolean = false) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.post<Blob>(`${hostUrl}/side/risk/customer-allow/${isEdit ? 'edit' : 'add'}`, params, { responseType: 'blob' });

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}